var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8474 15.1747L14.3915 12.6995C15.0941 12.0158 15.2683 10.9715 14.8239 10.1068L14.6798 9.82626C14.2354 8.96153 14.4096 7.91716 15.1122 7.23354L18.2666 4.16447C18.492 3.94518 18.8574 3.94518 19.0828 4.16447C19.1267 4.20714 19.1632 4.25642 19.1909 4.3104L20.4652 6.79004C21.4401 8.68699 21.0579 10.978 19.5166 12.4777L12.5923 19.2147C10.9145 20.8471 8.43275 21.4171 6.18176 20.6871L3.39479 19.7832C3.0924 19.6851 2.92898 19.3671 3.02977 19.0729C3.05811 18.9902 3.10584 18.9151 3.1692 18.8534L6.2295 15.8759C6.93213 15.1923 8.00554 15.0228 8.89431 15.4552L9.1826 15.5954C10.0714 16.0278 11.1448 15.8583 11.8474 15.1747Z",
    fill: "#29363D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c78f62e7748d1321a6db5ed70ba63962.svg";
export { ForwardRef as ReactComponent };